import { Column } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';
import { ContractStatusColumn, DateColumn, TextColumn, BrandColumn, DownloadFileColumn } from 'shared/tables/columns';
import { CustomerContractContextMenuColumn } from './customer-contract-context-menu-column';
import { sortBrands, sortContractStatus } from '../sorts';
import { ContractApprovalStatusColumn } from 'shared/tables/columns/contract-approval-status-column';

export const customerContractTableColumns: Column<CustomerContractInventoryGridItem>[] = [
  {
    Header: ' ',
    accessor: 'customerName',
    Cell: CustomerContractContextMenuColumn,
    align: 'left',
  },
  {
    Header: 'Document Name',
    accessor: 'originalDocumentName',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Brand',
    accessor: 'brand',
    Cell: BrandColumn,
    sortType: sortBrands,
    align: 'left',
  },
  {
    Header: 'Bill To Code',
    accessor: 'billToCode',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Document Status',
    accessor: 'status',
    Cell: ContractStatusColumn,
    sortType: sortContractStatus,
    align: 'left',
  },
  {
    Header: 'Approval Status',
    accessor: 'approvalStatus',
    Cell: ContractApprovalStatusColumn,
    align: 'left',
  },
  {
    Header: 'Agreement Start Date',
    accessor: 'startDate',
    Cell: DateColumn,
    align: 'left',
  },
  {
    Header: 'Agreement End Date',
    accessor: 'endDate',
    Cell: DateColumn,
    align: 'left',
  },
  {
    Header: 'Deleted Date',
    accessor: 'deletedAt',
    Cell: DateColumn,
    align: 'left',
    minWidth: 100,
  },
  {
    Header: 'Deleted By',
    accessor: 'deletedBy',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Contract Link',
    accessor: 'id',
    Cell: DownloadFileColumn,
    align: 'center',
  },
];
